import styled from 'styled-components';
import _Flag from 'components/Flag';
import { th } from 'style/theme';
import { sizes } from 'style';

export const TeamSearchWrapper = styled.div`
  display: block;
  position: sticky;
  top: 52px;
  background-color: ${th('colors.black')};
  z-index: 1;
  width: calc(100% + 40px);
  margin-left: -20px;
  padding: 0px 20px 10px 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-top: 14px;

  @media ${sizes.tabletPortrait} {
    max-width: 300px;
    position: relative;
    top: 0;
    width: 100%;
    margin-left: 0;
    padding: 0;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  @media ${sizes.desktop} {
    display: inline-block;
    vertical-align: top;
    margin-top: 0px;
  }

  @media ${sizes.mediumLargeDesktop} {
    display: block;
    vertical-align: baseline;
    margin-top: 16px;
  }
`;

export const InputContainer = styled.div`
  position: relative;

  > svg {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 2px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const SearchInput = styled.input`
  display: block;
  width: 100%;
  padding: 8px 0;
  border-radius: 0px;
  outline: none;
  border: 0px;
  border-bottom: 1px solid ${th('colors.white')};
  background-color: ${th('colors.black')};
  color: inherit;
  font-size: 16px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);

  ::placeholder {
    font-family: 'Helvetica Now', Arial, sans-serif;
    color: ${th('colors.transparentWhite.4')};
    font-style: italic;
    opacity: 1;
  }
`;

export const Options = styled.div`
  display: ${({ searchValue }) => (searchValue ? 'block' : 'none')};
  position: absolute;
  max-height: 200px;
  width: calc(100% - 40px);
  overflow: scroll;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: ${th('colors.white')};
  color: ${th('colors.black')};
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
  z-index: 1;

  @media ${sizes.tabletPortrait} {
    width: 100%;
    max-width: 300px;
  }
`;

export const Option = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 14px;
  cursor: pointer;

  :hover {
    background-color: ${th('colors.turquoise')}33;
  }
`;

export const Category = styled.span`
  color: ${th('colors.turquoise')};
  font-family: 'Times New Roman';
  font-style: italic;
  margin-left: 2px;
`;

export const Highlight = styled.span`
  font-weight: bold;
  text-decoration: underline;
`;

export const Name = styled.span`
  margin-right: 4px;
`;

export const Flag = styled(_Flag).attrs({ height: 12 })`
  margin-right: 8px;
`;
